const state = {
  subject: {},
  filters: {},
  baseInfo: {},
  grades: [],
  xuekeChoice: [],
  sections: {},
  years: {},
  origins: {},
  siteChoices: [],
  allRules: [],
  bindAccounts: [],
  reset: false,
  loginModal: false,
  user: null,
  user_info: {},
  payModal: {
    state: false,
    index: 0
  },
  tipModal: {
    status: false,
    error: ''
  },
  need_captcha: false,
  handoutShow: false
}
export default state
